(() => {
  'use strict';
  const INTERVAL = 4200;
  const FADE = 920;
  const ORDER = ['pink', 'beige', 'lilac'];
  function init(root) {
    if (root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';
    const stage = root.querySelector('[data-hero-stage]');
    const frames = ORDER.map(colour => root.querySelector(`[data-hero-frame="${colour}"]`));
    const controls = root.querySelector('[data-hero-controls]');
    const fallback = root.querySelector('[data-hero-fallback]');
    const play = root.querySelector('[data-hero-play]');
    const choices = [...root.querySelectorAll('[data-hero-colour]')];
    if (!stage || frames.some(frame => !frame) || !play) return;
    const base = frames[0].querySelector('img');
    if (!base || !base.src.includes(root.dataset.expectedBase)) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const rect = stage.getBoundingClientRect();
    let visible = rect.bottom > 0 && rect.top < innerHeight;
    let wanted = !reduced.matches, hovering = false, focused = false;
    let ready = false, destroyed = false, current = 0;
    let timer = null, fadeTimer = null, focusTimer = null;
    const abort = new AbortController();
    const on = (target, name, fn) => target.addEventListener(name, fn, {signal: abort.signal});
    function sync() {
      clearTimeout(timer); timer = null;
      play.textContent = wanted ? 'Pause' : 'Play';
      play.setAttribute('aria-label', wanted ? 'Pause colour animation' : 'Play colour animation');
      const running = ready && wanted && visible && !document.hidden && !hovering && !focused && !destroyed;
      root.dataset.running = String(running);
      root.dataset.visible = String(visible);
      if (running) timer = setTimeout(() => { show((current + 1) % frames.length); sync(); }, INTERVAL);
    }
    function show(index) {
      if (index === current) return;
      clearTimeout(fadeTimer);
      const previous = frames[current];
      frames.forEach(frame => { frame.dataset.outgoing = 'false'; frame.dataset.current = 'false'; });
      // Keep an opaque room underneath: fading both layers would flash the background.
      previous.dataset.outgoing = 'true';
      current = index;
      frames[current].dataset.current = 'true';
      const colour = ORDER[current];
      root.dataset.colour = colour;
      stage.setAttribute('aria-label', frames[current].dataset.description);
      choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.heroColour === colour)));
      fadeTimer = setTimeout(() => { previous.dataset.outgoing = 'false'; }, reduced.matches ? 0 : FADE);
    }
    choices.forEach(button => on(button, 'click', () => {
      wanted = false;
      show(ORDER.indexOf(button.dataset.heroColour));
      sync();
    }));
    on(play, 'click', () => {
      wanted = !wanted;
      // Explicit Play takes precedence over the pause caused by focusing this button.
      if (wanted) { clearTimeout(focusTimer); hovering = false; focused = false; }
      sync();
    });
    on(controls, 'keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      const at = choices.indexOf(event.target);
      if (at < 0) return;
      event.preventDefault();
      const next = (at + (event.key === 'ArrowRight' ? 1 : -1) + choices.length) % choices.length;
      choices[next].focus(); choices[next].click();
    });
    on(root, 'pointerenter', event => { if (event.pointerType === 'mouse') { hovering = true; sync(); } });
    on(root, 'pointerleave', () => { hovering = false; sync(); });
    on(root, 'focusin', () => { focused = true; sync(); });
    on(root, 'focusout', () => {
      clearTimeout(focusTimer);
      focusTimer = setTimeout(() => { focused = root.contains(document.activeElement); sync(); }, 0);
    });
    on(document, 'visibilitychange', sync);
    on(reduced, 'change', () => { if (reduced.matches) wanted = false; sync(); });
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .2;
      sync();
    }, {threshold: [0, .2]}) : null;
    if (observer) observer.observe(stage);
    function load(image) {
      return new Promise((resolve, reject) => {
        let timeout;
        const finish = error => {
          clearTimeout(timeout);
          image.removeEventListener('load', success); image.removeEventListener('error', failure);
          error ? reject(error) : resolve();
        };
        const success = () => finish();
        const failure = () => finish(new Error('Image unavailable'));
        image.addEventListener('load', success, {once: true});
        image.addEventListener('error', failure, {once: true});
        timeout = setTimeout(failure, 12000);
        if (image.dataset.src) {
          image.loading = 'eager';
          if (image.dataset.srcset) image.srcset = image.dataset.srcset;
          image.src = image.dataset.src;
        }
        if (image.complete && image.naturalWidth > 0) success();
      });
    }
    root.dataset.state = 'loading';
    sync();
    Promise.all(frames.map(frame => load(frame.querySelector('img')))).then(() => {
      if (destroyed) return;
      ready = true;
      root.dataset.state = 'ready';
      controls.hidden = false; fallback.hidden = true;
      sync();
    }).catch(() => { root.dataset.state = 'static'; wanted = false; sync(); });
    on(document, 'shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      destroyed = true;
      clearTimeout(timer); clearTimeout(fadeTimer); clearTimeout(focusTimer);
      if (observer) observer.disconnect();
      abort.abort();
    });
  }
  const scan = scope => scope.querySelectorAll('[data-cw-hero-colours]').forEach(init);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
